export const SearchConst = {
    SelectedDealer: 'SelectedDealer',
};
const initialState = null
console.log("initialState===", initialState)

const DealerReducer = (state = { payload: initialState }, action) => {
    switch (action.type) {
        case SearchConst.SelectedDealer:
            console.log("inside success reducer")
            console.log("Payload", action)
            return {
                search: 'search-searchrequest',
                payload: action.payload

            };
        default:
            console.log("Inside default of the reducer");
            console.log("Payload - state", state)
            return state

    }


}

export default DealerReducer; 